import { render, staticRenderFns } from "./EditServer.vue?vue&type=template&id=d9505d38&scoped=true&"
import script from "./EditServer.vue?vue&type=script&lang=js&"
export * from "./EditServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9505d38",
  null
  
)

export default component.exports